import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconThermometer = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--thermometer")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M16.7636124,20.0981767 C16.0603822,22.4164895 13.9230505,24.0016574 11.5004264,24.0016574 C9.0778024,24.0016574 6.94047069,22.4164895 6.23724051,20.0981767 C5.58806096,17.9580505 6.30214864,15.6584563 8.00042645,14.2587994 L8.00042645,3.5 C8.00042645,1.56700338 9.56742982,0 11.5004264,0 C13.4334231,0 15.0004264,1.56700338 15.0004264,3.5 L15.0004264,14.2587994 C16.6987043,15.6584563 17.4127919,17.9580505 16.7636124,20.0981767 Z M13.0004264,14.76 L13.0004264,3.5 C13.0004264,2.67157288 12.3288536,2 11.5004264,2 C10.6719993,2 10.0004264,2.67157288 10.0004264,3.5 L10.0004264,14.76 C10.0004264,15.0939889 9.83368687,15.40593 9.555982,15.5914794 C8.27411525,16.4479627 7.70361619,18.0423342 8.1511263,19.5176242 C8.59863642,20.9929142 9.9587566,22.0016574 11.5004264,22.0016574 C13.0420963,22.0016574 14.4022165,20.9929142 14.8497266,19.5176242 C15.2972367,18.0423342 14.7267376,16.4479627 13.4448709,15.5914794 C13.167166,15.40593 13.0004264,15.0939889 13.0004264,14.76 Z" id="icon--centivo--thermometer"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1367.000000, -1198.000000)"/>
          <g id="Icon/thermometer">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--thermometer"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--thermometer"/>
          </g>
      </g>
  </IconWrapper>
)
